import React from 'react'
import clsx from 'clsx'
import { useStyles } from './Clickable.styles'

interface IClickableProps {
  children: JSX.Element | JSX.Element[] | string
  className?: string
  component?: React.ElementType
  onClick: () => void
}

export const Clickable = ({ children, className, component = 'span', onClick }: IClickableProps) => {
  const classes = useStyles()
  const handleClick = (_: React.MouseEvent<HTMLSpanElement, MouseEvent>) => onClick()
  const Component = component

  return (
    <Component className={clsx(classes.root, className)} onClick={handleClick}>
      {children}
    </Component>
  )
}
